import { UIBox, UITypography, UIButton } from '@workspace/ui/composed';
import { LogOut, Moon, Sun, Globe } from 'lucide-react';
import { doLogout, getUsername, getUserEmail } from '../../utils/keycloak';
import { useTranslations, useLocale } from '../../i18n/useTranslations';
import { useTheme } from '../../hooks/useTheme';

function Header() {
  const { t } = useTranslations();
  const { locale, toggleLocale } = useLocale();
  const { toggleTheme } = useTheme();
  const username = getUsername();
  const email = getUserEmail();

  const handleLogout = () => {
    doLogout();
  };

  const handleLogoClick = () => {
    window.location.href = '/';
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b border-border h-16">
      <UIBox className="flex items-center justify-between h-full px-4 gap-4">
        {/* Logo - web 앱 스타일과 동일하게 */}
        <UIBox
          onClick={handleLogoClick}
          className="flex items-center gap-3 cursor-pointer hover:opacity-80 transition-opacity"
        >
          <UIBox className="bg-transparent dark:bg-white flex aspect-square size-8 items-center justify-center rounded-lg">
            <img src="/dnotitia-logo.svg" alt="Dnotitia logo" className="size-6" />
          </UIBox>
          <UIBox className="grid flex-1 text-left text-sm leading-tight">
            <UITypography variant="p" className="truncate font-semibold">
              Seahorse Cloud
            </UITypography>
            <UITypography variant="p" className="truncate text-xs text-muted-foreground">
              account console
            </UITypography>
          </UIBox>
        </UIBox>

        {/* Right menu items */}
        <UIBox className="flex items-center gap-2">
          {/* Theme toggle */}
          <UIButton
            variant="ghost"
            size="icon"
            onClick={toggleTheme}
            className="h-8 w-8"
          >
            <UIBox className="relative h-4 w-4">
              <Sun className="absolute h-4 w-4 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
              <Moon className="absolute h-4 w-4 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
            </UIBox>
            <span className="sr-only">Toggle theme</span>
          </UIButton>

          {/* Language toggle */}
          <UIButton
            variant="ghost"
            size="icon"
            onClick={toggleLocale}
            className="h-8 w-8"
            title={locale === 'en' ? '한국어로 변경' : 'Switch to English'}
          >
            <Globe className="h-4 w-4" />
            <span className="sr-only">Toggle language</span>
          </UIButton>

          {/* User info */}
          <UITypography variant="p" className="text-sm text-muted-foreground ml-2">
            {email || username}
          </UITypography>

          {/* Logout button */}
          <UIButton
            variant="ghost"
            onClick={handleLogout}
            className="flex items-center gap-2"
          >
            <LogOut className="h-4 w-4" />
            {t('common.logout')}
          </UIButton>
        </UIBox>
      </UIBox>
    </header>
  );
}

export default Header;
